var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNarratives(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.75C12.25 5.26472 10.2353 3.25 7.75 3.25C5.26472 3.25 3.25 5.26472 3.25 7.75C3.25 10.2353 5.26472 12.25 7.75 12.25C10.2353 12.25 12.25 10.2353 12.25 7.75ZM13.75 7.75C13.75 11.0637 11.0637 13.75 7.75 13.75C4.4363 13.75 1.75 11.0637 1.75 7.75C1.75 4.4363 4.4363 1.75 7.75 1.75C11.0637 1.75 13.75 4.4363 13.75 7.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7503 12.2499C16.7503 9.76463 14.7353 7.75 12.25 7.75C9.76471 7.75 7.75 9.76471 7.75 12.25C7.75 14.7353 9.76504 16.7499 12.2503 16.7499C14.7356 16.7499 16.7503 14.7352 16.7503 12.2499ZM18.2503 12.2499C18.2503 15.5636 15.564 18.2499 12.2503 18.2499C8.93661 18.2499 6.25033 15.5636 6.25033 12.2499C6.25033 8.93621 8.93661 6.24992 12.2503 6.24992C15.564 6.24992 18.2503 8.93621 18.2503 12.2499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarratives);
export default __webpack_public_path__ + "static/media/narratives.9cfdde57bf6680cc1e02dac8898652f2.svg";
export { ForwardRef as ReactComponent };